import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.7 Nu ești singur în județul tău ── */
export function HomeCounty() {
  const c = useSectionContent("home_county");
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/public/ro-map").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || data.total_located < 1) return null;
  return (
    <section className="py-14" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-2xl mx-auto px-5 text-center">
        <MapPin size={26} className="mx-auto mb-3" style={{ color: "var(--ct-link)" }} />
        <h2 data-el="title" className="font-serif text-2xl sm:text-3xl mb-2">
          {data.judete >= 3
            ? (<>În <span style={{ color: "var(--ct-link)" }}>{data.judete}</span> <span data-field="title_multi_suffix">{c.title_multi_suffix || "județe din țară cresc deja copaci"}</span></>)
            : (<span data-field="title_single">{c.title_single || "Pe harta României au răsărit primii copaci"}</span>)}
        </h2>
        <p data-el="subtitle" data-field="subtitle" className="text-sm mb-5" style={{ color: "var(--ct-text-muted)" }}>{c.subtitle || "Nu ești singur nici în orașul tău. Undeva aproape, cineva merge pe același drum."}</p>
        <Link data-el="cta" to="/padurea" className="btn-ghost text-sm"><Sparkles size={14} /> <span data-field="cta">{c.cta || "Vezi harta vie a României"}</span></Link>
      </div>
    </section>
  );
}
